import {trackAmplitudeEvent} from "@pg-mono/amplitude";

import {AmplitudeSemanticSearchModalSize} from "./get_semantic_search_modal_size";

export const trackAmplitudeOpenAiChat = (modalSize: AmplitudeSemanticSearchModalSize, analyticSessionId: string | null | undefined) => {
    trackAmplitudeEvent("open_ai_chat", {
        modal_size: modalSize,
        analytic_session_id: analyticSessionId ?? null
    });
};
import {trackAmplitudeEvent} from "@pg-mono/amplitude";

import {AmplitudeSemanticSearchModalSize} from "./get_semantic_search_modal_size";

export const trackAmplitudeOpenAiChat = (modalSize: AmplitudeSemanticSearchModalSize, analyticSessionId: string | null | undefined) => {
    trackAmplitudeEvent("open_ai_chat", {
        modal_size: modalSize,
        analytic_session_id: analyticSessionId ?? null
    });
};
